import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
	const { isAuthenticated, isInitializing } = useAuth();
	if (isInitializing) {
		return null;
	}
	if (!isAuthenticated) {
		return <Navigate to="/login/" replace />;
	}
	return children;
};

export default ProtectedRoute; 